import { useSelector } from "react-redux";

/**
 * Custom hook to check sales user authentication state
 * @returns {Object} { isAuthenticated, user, loading, error }
 */
export const useSalesAuth = () => {
  const salesState = useSelector((state) => state.sales);

  return {
    isAuthenticated: salesState.isAuthenticated,
    user: salesState.user,
    loading: salesState.loading,
    error: salesState.error,
  };
};
